import React from 'react';

const TableIcon = ({ children }) => {
    return (
        <div className='table-icon-container'>
            <div className='table-icon'>{children}</div>
        </div>
    );
};

export default TableIcon;
